import CreateArticleView from "../Vue/Pages/CreateArticleView";

const CreateArticleController = () => {
    return (CreateArticleView())
  }
  
  export default CreateArticleController;